import classNames from "classnames";
import { isNotNil, setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import { EventCardColor, eventCardColorToStylesMap } from "./EventCard";
import styles from "./EventCard.module.less";

export type PlaceholderEventCardProps = {
	color?: EventCardColor | null;
	trackingId: string;
};

export const PlaceholderEventCard = (props: PlaceholderEventCardProps): ReactElement => {
	const {
		color,
		trackingId
	} = props;

	const colorStyle: string | undefined = isNotNil(color)
		? eventCardColorToStylesMap[color]
		: undefined;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				colorStyle
			)}
		/>
	);
};
PlaceholderEventCard.displayName="PlaceholderEventCard";
